/** Discover → Connections (AUTO-8). Thin wrapper around <CatalogBrowsePage>. */

import { createFileRoute } from '@tanstack/react-router';
import { Plug } from 'lucide-react';
import { CatalogBrowsePage } from '@/components/discover/catalog-browse-page';

export const Route = createFileRoute('/admin/discover/connections')({
  component: DiscoverConnectionsPage,
});

function DiscoverConnectionsPage() {
  return (
    <CatalogBrowsePage
      kind="connection"
      title="Connections"
      description="MCP server connectors — both system-shipped catalog entries and tenant-installed external systems (SAP, ServiceNow, custom REST). Manage tenant-side installs in Connections."
      icon={Plug}
    />
  );
}
